import { render } from "./Sourcing.vue?vue&type=template&id=89bdb38c"
import script from "./Sourcing.vue?vue&type=script&lang=js"
export * from "./Sourcing.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__